
export const USER = {
  firstName: "Rohit",
  lastName: "Lohar",
  displayName: "Rohit Lohar",
  username: "rohitlohar",
  gender: "male",
  pronouns: "he/him",
  bio: "Full-stack developer with 1+ year of experience in Go, Kubernetes, Docker, and React.",
  flipSentences: [
    "Software Engineer",
    "Open Source Contributor",
    "1+ year of experience in React, Go, Docker, and Kubernetes.",
  ],
  address: "Pune, Maharashtra, India",
  phoneNumber: "Kys5NjMyNTY4MDY5Ng==", // E.164 format, base64 encoded (+91 9325680696)
  email: "bG9oYXJyb2hpdDQ1QGdtYWlsLmNvbQ==", // base64 encoded (loharrohit45@gmail.com)
  website: "https://rohitlohar.vercel.app",
  otherWebsites: [
    "https://github.com/rohitlohar45",
    "https://linkedin.com/in/rohitlohar",
  ],
  jobTitle: "Software Engineer",
  jobs: [
    {
      title: "Software Engineer",
      company: "IBM (ISDL)",
      website: "https://www.ibm.com",
    },
    {
      title: "Software Engineer",
      company: "Lumeneo.ai",
      website: "https://lumeneo.ai",
    },
    {
      title: "SDE (Full-time + Intern)",
      company: "Diamanti",
      website: "https://diamanti.com",
    },
  ],
  about:
    `
Hello, World! 👋 I am **Rohit Lohar** — a _Full-stack developer_ passionate about building **fast, scalable systems** with modern technologies.

With **1+ year** of hands-on experience, I specialize in **React**, **Go**, **Docker**, and **Kubernetes**. I'm skilled at building **high-performance applications** and have a strong background in **debugging**, **system design**, and **developer tooling**.

Currently working as a **Software Engineer at IBM**, where I'm still exploring the actual work while diving into new challenges.

Previously at **Lumeneo.ai**, I built **fast React UIs** using \`Vite\`, optimized **Docker images** with **multistage builds**, and created **real-time dashboards** with \`WebSockets\`. I've also processed **10K+ messages/sec** with \`Go\`, \`Kafka\`, and \`WebSockets\`.

Before that, at **Diamanti**, I tuned **Kubernetes workloads** to reduce usage by **40%** and delivered **3 production releases** improving performance and reliability. I also optimized **VM settings**, cutting **cloud costs by 25%**.

I'm also an **active open source contributor**, having contributed to projects like **Traefik**, **grpc-gateway**, and **jaeger-ui**. My projects include **ai-cli** (a command-line AI assistant) and **DistCache** (a Go tool for distributed caching).

I hold a **B.E. in Information Technology** from **AISSMS IOIT, Pune** with a \`CGPA of 8.9\`, and I'm a **Certified Kubernetes Administrator (CKA)**.

> ⚡ **Let's connect and collaborate!**
`
  ,

  avatar: "/r/pfp.jpeg",
  ogImage: "https://assets.rohitlohar.vercel.app/images/screenshot-og-image-dark.png",
  namePronunciationUrl: "https://assets.rohitlohar.vercel.app/audio/rohitlohar.mp3",
  keywords:
    "rohitlohar, rohit lohar, software engineer, full stack developer, react, go, docker, kubernetes, lumeneo, diamanti",
  dateCreated: "2024-01-01", // YYYY-MM-DD
};
